export function registerErrorSpanBlot(Quill: any) {
  const Inline = Quill.import('blots/inline');

  class ErrorSpanBlot extends Inline {
    static create(value: any) {
      const node = super.create();

      if (typeof value === 'string') {
        node.setAttribute('id', value);
        return node;
      }

      if (typeof value === 'object') {
        Object.entries(value).forEach(([key, val]) => {
          if (key === 'class') {
            node.classList.add(...String(val).split(' '));
          } else if (key === 'style' && typeof val === 'object') {
            Object.entries(val).forEach(([prop, styleVal]) => {
              node.style[prop] = styleVal;
            });
          } else if (key === 'correction') {
            node.setAttribute('data-correction', val);
          } else {
            node.setAttribute(key, val);
          }
        });
      }

      return node;
    }

    static formats(node: HTMLElement) {
      const formats: any = {};

      const attributes = node.attributes;
      for (let i = 0; i < attributes.length; i++) {
        const attr = attributes[i];
        const name = attr.name;
        const value = attr.value;

        if (name === 'class') {
          formats.class = value;
        } else if (name === 'style') {
          formats.style = value;
        } else if (name === 'data-correction') {
          formats.correction = value;
        } else {
          formats[name] = value;
        }
      }

      return formats;
    }
  }

  ErrorSpanBlot['blotName'] = 'error-span';
  ErrorSpanBlot['tagName'] = 'span';

  Quill.register(ErrorSpanBlot);

  const clipboard = Quill.import('modules/clipboard');
  const originalMatcher = clipboard.DEFAULTS.matchers;

  clipboard.DEFAULTS.matchers = [
    [
      'span[id], span[class], span[data-correction]',
      function (node, delta) {
        const newDelta = delta;

        const formats = {};
        const attributes = node.attributes;
        for (let i = 0; i < attributes.length; i++) {
          const attr = attributes[i];
          const name = attr.name;
          const value = attr.value;

          formats[name] = value;
        }

        newDelta.ops.forEach((op) => {
          if (op.insert && typeof op.insert === 'string') {
            op.attributes = op.attributes || {};
            op.attributes['error-span'] = formats;
          }
        });

        return newDelta;
      },
    ],
    ...originalMatcher,
  ];

  return ErrorSpanBlot;
}
